import {
  ArchiveIcon,
  AreaChart,
  Coins,
  DollarSign,
  FileSignature,
  FileSpreadsheet,
  FileText,
  Hammer,
  HandshakeIcon,
  PieChart,
  Receipt,
  ReceiptTextIcon,
  Repeat2,
  Settings2Icon,
  ShoppingBasket,
  SquareX,
  Table2,
  Table2Icon,
  TableProperties,
  TablePropertiesIcon,
  TicketIcon,
  Trophy,
  UserCog,
  UserRound,
  WandSparkles,
  Goal,
  Table
} from 'lucide-react'

export type Route = {
  label: string;
  Icon: JSX.Element;
  path: string | Route[];
  permission?: string;
  showOnlyWithCompanyKind?: string;
  hidden?: boolean;
  verifyFullRouteToActive?: boolean;
  cmModuleShouldBeEnabled?: boolean;
  tmaisModuleShouldBeEnabled?: boolean;
}

const routes: Route[] = [
  {
    label: 'Minha empresa',
    Icon: <PieChart strokeWidth={1} />,
    path: '/company',
    permission: 'Establishment::Dashboard::Groups::Mine',
  },
  {
    label: 'Relatórios',
    Icon: <FileSpreadsheet strokeWidth={1} />,
    path: '/reports',
    permission: 'Establishment::Reports::Entries::PermittedReportsFilter',
  },
  {
    label: 'Tabelas ANP',
    Icon: <Table strokeWidth={1} />,
    path: '/anp-reports',
    permission: 'Establishment::Anp::Reports::Filter',
  },
  {
    label: 'Tabelas Série Histórica Mensal ANP',
    Icon: <Table strokeWidth={1} />,
    path: '/anp-historical-reports',
    permission: 'Establishment::Anp::HistoricalReports::Filter',
  },
  {
    label: 'Negociações',
    Icon: <HandshakeIcon strokeWidth={1} />,
    path: '/negotiations',
    permission: 'Establishment::Client::Negotiations::Filter',
  },
  {
    label: 'Financeiro',
    Icon: <Coins strokeWidth={1} />,
    path: [
      {
        label: 'Transações',
        Icon: <Receipt strokeWidth={1} />,
        path: '/billing-events',
        permission: 'Establishment::Billing::Events::Filter',
      },
      {
        label: 'Transações falhas',
        Icon: <Receipt strokeWidth={1} />,
        path: '/failed-transactions',
        permission: 'Establishment::Client::Consumptions::Filter',
      },
      {
        label: 'Totalizadores',
        Icon: <AreaChart strokeWidth={1} />,
        path: '/movements-totalizer',
        permission: 'Establishment::Companies::MovementsTotalizer',
      },
      {
        label: 'Faturas',
        Icon: <FileText strokeWidth={1} />,
        path: '/billing-bills',
        permission: 'Establishment::Billing::Bills::Filter',
      },
      {
        label: 'Antecipáveis de Fatura',
        Icon: <ArchiveIcon strokeWidth={1} />,
        path: '/payment-advances',
        permission: 'Establishment::Billing::PaymentAdvances::Filter',
      },
    ],
  },
  {
    label: 'Recolha de notas fiscais',
    Icon: <Repeat2 strokeWidth={1} />,
    path: [
      {
        label: 'Por transações',
        Icon: <Coins strokeWidth={1} />,
        path: '/events-with-fiscal-document-requirement',
        permission: 'Establishment::Billing::FiscalDocumentGroups::Filter',
      },
      {
        label: 'Por lote',
        Icon: <TableProperties strokeWidth={1} />,
        path: '/billing-fiscal-document-groups',
        permission: 'Establishment::Billing::FiscalDocumentGroups::Filter',
      },
    ],
  },
  {
    label: 'Tabela de preços',
    Icon: <Table2 strokeWidth={1} />,
    path: '/product-prices',
    permission: 'Establishment::ProductPrices::Filter',
  },
  {
    label: 'Encaminhamentos de manutenção',
    Icon: <ReceiptTextIcon strokeWidth={1} />,
    path: '/maintenance-forwardings',
    permission: 'Establishment::Maintenance::Forwardings::Filter',
    cmModuleShouldBeEnabled: true,
  },
  {
    label: 'Leilões de manutenção',
    Icon: <Hammer strokeWidth={1} />,
    path: '/maintenance-establishment-choice/auction-entries',
    permission: 'Establishment::Maintenance::EstablishmentChoice::AuctionEntries::Following',
    cmModuleShouldBeEnabled: true,
  },
  {
    label: 'Propostas de manutenção',
    Icon: <FileSignature strokeWidth={1} />,
    path: '/maintenance-proposals',
    permission: 'Establishment::Maintenance::EstablishmentChoice::ManualEntryProposals::Filter',
    cmModuleShouldBeEnabled: true,
  },
  {
    label: 'Configurações TEF',
    Icon: <Settings2Icon strokeWidth={1} />,
    path: [
      {
        label: 'Tabela de códigos Fiserv',
        Icon: <Table2Icon strokeWidth={1} />,
        path: '/tef-configurations/fiserv',
        permission: 'Establishment::TefProductCodes::Filter',
        verifyFullRouteToActive: true,
      },
      {
        label: 'Tabela de códigos Linx',
        Icon: <TablePropertiesIcon strokeWidth={1} />,
        path: '/tef-configurations/linx',
        permission: 'Establishment::TefProductCodes::Filter',
        verifyFullRouteToActive: true,
      },
    ],
  },
  {
    label: 'Transações',
    Icon: <DollarSign strokeWidth={1} />,
    path: [
      {
        label: 'Consumo',
        Icon: <Receipt strokeWidth={1} />,
        path: '/consumption',
        permission: 'Establishment::Client::Consumptions::Create',
      },
      {
        label: 'Consulta',
        Icon: <WandSparkles strokeWidth={1} />,
        path: '/card-current-limit',
        permission: 'Establishment::Client::Cards::CurrentLimits',
      },
      {
        label: 'Estorno',
        Icon: <SquareX strokeWidth={1} />,
        path: '/refund',
        permission: 'Establishment::Billing::Refunds::Create',
      },
    ],
  },
  {
    label: 'Usuários',
    Icon: <UserRound strokeWidth={1} />,
    path: '/users',
    permission: 'Establishment::Users::Filter',
  },
  {
    label: 'Chamados',
    Icon: <TicketIcon strokeWidth={1} />,
    path: '/support',
    permission: 'Establishment::Support::Tickets::Filter',
  },
  {
    label: 'Taurus +',
    Icon: <img src="/TaurusMaisLogo.svg" />,
    tmaisModuleShouldBeEnabled: true,
    path: [
      {
        label: 'Itens para Resgate',
        Icon: <ShoppingBasket strokeWidth={1} />,
        path: '/tmais-reward-items',
        permission: 'Establishment::Tmais::Products::Filter',
      },
      {
        label: 'Sorteios',
        Icon: <Trophy strokeWidth={1} />,
        path: '/tmais-raffles',
        permission: 'Establishment::Tmais::Raffles::Filter',
      },
      {
        label: 'Clientes T+',
        Icon: <UserCog strokeWidth={1} />,
        path: '/tmais-users',
        permission: 'Establishment::Tmais::Users::Filter',
      },
      {
        label: 'Missões',
        Icon: <Goal strokeWidth={1} />,
        path: '/tmais-missions',
        permission: 'Establishment::Tmais::Missions::Filter',
      },
    ],
  },
]

const flattenRoutes: any = (items: typeof routes) => items.flatMap((item) => {
  if (Array.isArray(item.path))
    return flattenRoutes(item.path)

  if (typeof item.path === 'string')
    return { ...item }

  return [];
})

export const flattedRoutes: typeof routes = flattenRoutes(routes)

export default routes
